export interface RunOfShowServerRenderRequest {
  eventId: number;
  token: string;
}

const RUN_OF_SHOW_PRINT_PATH =
  /^\/(?:client\/)?events\/([1-9]\d*)\/run-of-show$/;

/**
 * Recognize the short-lived headless-render entry point.
 *
 * The signed credential stays in the URL fragment, which browsers never send
 * in HTTP requests or access logs. The print app exchanges it through the
 * dedicated request header after boot.
 */
export function getRunOfShowServerRenderRequest(
  location: Pick<URL, 'pathname' | 'searchParams' | 'hash'>,
): RunOfShowServerRenderRequest | null {
  if (location.searchParams.get('print') !== '1') {
    return null;
  }

  const pathMatch = RUN_OF_SHOW_PRINT_PATH.exec(location.pathname);
  if (!pathMatch) {
    return null;
  }

  const fragment = new URLSearchParams(location.hash.replace(/^#/, ''));
  const token = fragment.get('rosRenderToken');
  if (!token) {
    return null;
  }

  const eventId = Number(pathMatch[1]);
  if (!Number.isSafeInteger(eventId) || eventId <= 0) {
    return null;
  }
  return { eventId, token };
}
